import { FileManagerItem } from './types/FileManagerItem';

export const fileManagerSortings: Map<
  string, (a: FileManagerItem, b: FileManagerItem) => number> = new Map([
    ['createdDate', (a: FileManagerItem, b: FileManagerItem) => a.createdDate.getTime() - b.createdDate.getTime()],
    ['modifiedDate', (a: FileManagerItem, b: FileManagerItem) => a.modifiedDate.getTime() - b.modifiedDate.getTime()],
    ['modifiedDateReverse', (a: FileManagerItem, b: FileManagerItem) => b.modifiedDate.getTime() - a.modifiedDate.getTime()],
    ['createdDateReverse', (a: FileManagerItem, b: FileManagerItem) => b.createdDate.getTime() - a.createdDate.getTime()],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ['name', (a: FileManagerItem, b: FileManagerItem): any => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    }],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ['nameReverse', (a: FileManagerItem, b: FileManagerItem): any => {
      if (a.name > b.name) { return -1; }
      if (a.name < b.name) { return 1; }
      return 0;
    }],
  ]);
